import { Card, CardBody, Col, Toast, ToastBody } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { ColorsScheme } from "../../../../Constant";
import { COLORS_SCHEMES } from "../../../../Data/Bonus Ui/Toasts";
import { useState } from "react";
import { Btn } from "../../../../AbstractElements";

const ColorsSchemes = () => {
  const [open,setOpen] = useState(true)
  return (
    <Col md="6">
      <Card>
        <CommonCardHeader title={ColorsScheme} span={COLORS_SCHEMES} />
        <CardBody className="toast-rtl">
          <Toast fade className="default-show-toast align-items-center text-light bg-warning border-0" isOpen={open}>
            <div className="d-flex justify-content-between">
              <ToastBody>Your time over after 5 minute.</ToastBody>
              <Btn className="btn-close btn-close-white me-2 m-auto" onClick={() => setOpen(false)}></Btn>
            </div>
          </Toast>
        </CardBody>
      </Card>
    </Col>
  );
};

export default ColorsSchemes;
